module.exports = __webpack_public_path__ + "static/media/design-virtual-exhibitions.a5b85f13.png";